/* eslint-disable max-len */
import { Errors } from './constants';

export const listErrorsRequest = () => ({ type: Errors.listErrorsRequest });
export const listErrorsSuccess = (data) => ({ type: Errors.listErrorsSuccess, data });
export const listErrorsError = () => ({ type: Errors.listErrorsError });
